// API 클라이언트 유틸리티 / API client utility
import { Api } from './generated/swagger.api';

/**
 * 사용자 ID 가져오기 / Get user ID from localStorage
 * @returns 사용자 ID / User ID
 */
const getUserId = (): string | null => {
  try {
    const userInfo = localStorage.getItem('kpc_user_info');
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      return parsed.id?.toString() || null;
    }
  } catch (error) {
    console.error('사용자 정보를 가져오는데 실패했습니다 / Failed to get user info:', error);
  }
  return null;
};

/**
 * 환경에 따른 API 인스턴스 생성 / Create API instance based on environment
 * @returns API 인스턴스 / API instance
 */
export const createApiClient = (): Api<unknown> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL || 'https://ailic.kpc.or.kr';
  
  return new Api({ 
    baseUrl
  });
};

// 기본 API 인스턴스 / Default API instance
export const apiClient = createApiClient();
